<div class="absolute top-0 focus-within:z-[10000]">
  <idp-skip-navigation
    [buttonLabel]="buttonLabel"
    (focusFirstElEvent)="focusHeader()"
  ></idp-skip-navigation>
</div>
